<!-- 新增订单累计金额促销活动 -->
<template>
  <div class="addAmount">
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <el-scrollbar style="height:calc(100% - 50px)">
      <div style="height:20px;"></div>
      <el-form ref="form" label-width="120px" :model="addForm" :rules="formRule">
        <el-form-item label="活动名称：" prop="title">
          <el-input style="width:250px;" v-model="addForm.title" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="开始日期：" prop="start">
          <el-date-picker style="width:250px;" v-model="addForm.start" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="end">
          <el-date-picker style="width:250px;" v-model="addForm.end" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户类型：" prop="clientType">
          <el-checkbox-group v-model="addForm.clientType">
            <el-checkbox v-for="item in userTypeList" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="会员等级：" prop="grade">
          <el-select v-model="addForm.grade" placeholder="请选择" style="width: 200px;">
            <el-option v-for="item in memberGrade" :key="item" :label="'等级' + item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择" style="width: 200px;">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动方案：">
          <div class="details" v-for="(item, index) in addForm.details" :key="index">
            <span>满足金额：</span>
            <el-input-number v-model="item.MeetAmount" :min="0" :controls="false"></el-input-number>
            <!-- <span v-if="index > 0">{{ item.MeetAmount }}</span> -->
            <span style="margin-left:10px;">满足数量：</span>
            <el-input-number v-model="item.MaxNum" :min="0" :controls="false"></el-input-number>
            <!-- <span v-if="index > 0">{{ item.MaxNum }}</span> -->
            <span style="margin-left:10px;">排序：</span>
            <el-input-number v-model="item.SortId" :min="1" :controls="false"></el-input-number>
            <div style="margin-left:10px;">
              <el-button v-if="index == 0" type="text" @click="handleAddDetails()">添加</el-button>
              <el-button v-if="index > 0" type="text" @click="handleAddGiven(index)">赠品</el-button>
              <el-button v-if="index > 0" type="text" @click="handleDelDetails(index)">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-button type="default" @click="goBack">返回</el-button>
          <el-button type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>

    <!-- 赠品详情 -->
    <el-dialog title="赠品详情" :visible.sync="givenDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="700px">
      <div class="given">
        <el-form :model="givenForm" :rules="givenRule" ref="form2" label-width="100px">
          <div class="form-item">
            <el-form-item label="赠送类型：" prop="GivenType">
              <el-select v-model="givenForm.GivenType" placeholder="请选择" style="width: 200px;">
                <el-option v-for="item in givenType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序：" prop="SortId">
              <el-input-number style="width: 200px;" v-model="givenForm.SortId" :min="1" :controls="false">
              </el-input-number>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item v-show="givenForm.GivenType == 'JF1' || givenForm.GivenType == 'YE1'" label="赠送金额："
              prop="GivenAmount">
              <el-input-number style="width: 200px;" v-model="givenForm.GivenAmount" :min="0" :controls="false">
              </el-input-number>
            </el-form-item>
            <el-form-item v-show="givenForm.GivenType == 'ZP1'" label="商品：" prop="GoodsName">
              <el-input :readonly="true" style="width:200px;" placeholder="双击选择" v-model="givenForm.GoodsName"
                @dblclick.native="getSatisfyData('goods')"></el-input>
            </el-form-item>
            <el-form-item label="优惠券：" prop="GoodsName" v-show="givenForm.GivenType == 'YQ1'">
              <el-input :readonly="true" style="width:200px;" placeholder="双击选择" v-model="givenForm.GoodsName"
                @dblclick.native="getSatisfyData('coupon')"></el-input>
            </el-form-item>
            <el-form-item label="赠送数量：" prop="GivenQuantity">
              <el-input-number style="width: 200px;" v-model="givenForm.GivenQuantity" :min="1" :controls="false">
              </el-input-number>
            </el-form-item>
          </div>
          <el-form-item label="">
            <el-button type="default" @click="handleGivenReset">重置</el-button>
            <el-button type="primary" @click="handleGivenSave">保存</el-button>
          </el-form-item>
        </el-form>
        <!-- 数据展示 -->
        <el-table height="300px" :data="this.addForm.details[detailsIndex].givenList" stripe border
          tooltip-effect="dark" style="width: 100%">
          <el-table-column label="序号" align="center" width="50" type="index">
          </el-table-column>

          <el-table-column align="center" prop="GivenType" show-overflow-tooltip label="赠送类型">
          </el-table-column>
          <el-table-column align="center" prop="GivenAmount" show-overflow-tooltip label="赠送金额">
          </el-table-column>
          <el-table-column align="center" prop="GivenQuantity" show-overflow-tooltip label="赠送数量">
          </el-table-column>
          <el-table-column align="center" prop="GoodsName" show-overflow-tooltip label="优惠券/商品">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="handleGivenDel(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 满足条件选择 -->
    <el-dialog title="商品列表" :visible.sync="satisfyVisible" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="70%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入编号/名称"
            v-model="satisfySearch.name"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getSatisfyData(selectType)">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="satisfyListData" stripe border tooltip-effect="dark" height="300px" @row-click="clickTr">
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{
                (currPageSatisfy - 1) * pageSizeSatisfy + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(value, key) in satisfyListDataHead" align="center" :key="key" show-overflow-tooltip
          :label="value">
          <template slot-scope="scope">
            <span>{{ scope.row[key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPageSatisfy" :pageSize="pageSizeSatisfy" :currIndex="currPageSatisfy"
        @hanCurrChange="hanCurrChangeSatisfy" layout="total, prev, pager, next, jumper"></pagination>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';//表单验证
import { mustFill } from "@/mixins/data/valid.js";
export default {
  name: 'addAmount',
  data() {
    return {
      entId: "",//机构id
      /**方案活动的方案编号 */
      fabh: "",
      addForm: {
        fabh: "",//方案编号
        entId: "",//机构ID
        title: "",
        addTime: "",
        start: "",
        end: "",
        clientType: [],//客户类型
        grade: 1,//客户等级
        status: "2",
        details: [
          {
            // Fabh:"",
            SortId: 1,
            MeetAmount: 0,
            MaxNum: 0,
            givenList: []
          }
        ],//赠送方案
      },
      formRule: {
        title: [mustFill],
        start: [mustFill],
        end: [mustFill],
        clientType: [mustFill],
        grade: [mustFill],
        status: [mustFill]
      },
      /**表单选择数据 */
      detailsIndex: 0,//点击的方案详情
      userTypeList: [],
      givenType: [{
        label: "优惠券",
        value: "YQ1"
      }, {
        label: "积分",
        value: "JF1"
      }, {
        label: "现金红包",
        value: "YE1"
      }, {
        label: "赠品",
        value: "ZP1"
      }],//YQ1 优惠券 JF1 积分 YE1 现金红包 ZP1赠品
      memberGrade: [1, 2, 3, 4, 5],// 会员等级
      givenDialog: false,//赠品dialog
      givenForm: {
        ItemId: 0,
        ItemNo: "",
        // Fabh: "",
        SortId: 1,
        GivenType: "YQ1",//赠送类型
        GivenAmount: 1,//赠送金额
        GivenQuantity: 1,// 赠送数量
        GoodsCode: "",//赠送货品编号优惠券/商品编号
        GoodsName: "",//赠送货品编号优惠券/商品名称
      },// 赠品表单
      givenRule: {
        GivenType: [mustFill],
        GoodsName: [mustFill],
        GivenAmount: [mustFill],
        GivenQuantity: [mustFill]
      },
      /**搜索商品和优惠券 */
      selectType: "goods",
      satisfyVisible: false,
      currPageSatisfy: 1,
      pageSizeSatisfy: 10,
      allPageSatisfy: 0,
      satisfySearch: {
        name: "",
      },
      satisfyListData: [],
      satisfyListDataHead: {},
    }
  },
  mounted() {
    this.entId = window.localStorage.getItem("entId");
    if ('Fabh' in this.$route.query) {
      this.fabh = this.$route.query.Fabh;
      this.getDetails();
    }

    this.getUserType();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    /**
     * 获取方案详情
     */
    getDetails() {
      let data = {
        fabh: this.fabh
      }
      this.$request({
        url: "/Management/PromAdmin/GetOrderPromDetail",
        method: "post",
        data
      }).then((res) => {
        if (res.success) {
          this.addForm.entId = res.model.EntId;
          this.addForm.fabh = res.model.Fabh;
          this.addForm.title = res.model.Title;
          this.addForm.start = res.model.StartDate;
          this.addForm.end = res.model.EndDate;
          this.addForm.status = res.model.Status.toString();
          this.addForm.clientType = res.model.ClientType.split(',');
          this.addForm.grade = parseInt(res.model.MemberGrade);
          res.model.Detail.forEach(item => {
            this.addForm.details.push({
              // Fabh: item.Fabh,
              SortId: item.SortId,
              MeetAmount: item.MeetAmount,
              MaxNum: item.MaxNum,
              givenList: item.Item
            })
          });
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },

    /* 获取会员类型 */
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /*****方案详情操作 */
    /**
     * 添加方案
     */
    handleAddDetails() {
      this.addForm.details.unshift({
        SortId: this.addForm.details.length + 1,
        MeetAmount: 0,
        MaxNum: 0,
        givenList: []
      })
    },

    /**获取商品/优惠券 */
    getSatisfyData(searchType) {
      // 如果selectType = type的内容不一样，需要将分页修改
      if (this.selectType != searchType) {
        this.currPageSatisfy = 1;
      }
      this.selectType = searchType;

      let data = {
        type: "GoodsListHG",
        PageIndex: this.currPageSatisfy,
        PageSize: this.pageSizeSatisfy,
        strWhere: this.satisfySearch.name,
      };

      if (searchType == "goods") {
        data.type = "GoodsListHG";
      } else if (searchType == "coupon") {
        data.type = "IntegralGoodsChoiceCoupon";
      }

      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.satisfyListData = res.content;
            this.satisfyListDataHead = res.fdname;
            this.allPageSatisfy = res.recordCount;
            this.satisfyVisible = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**选中搜索数据中某一行数据 */
    clickTr(row) {
      if (this.selectType == "goods") {
        this.givenForm.GoodsCode = row.goodscode;
        this.givenForm.GoodsName = row.sub_title;
      } else if (this.selectType == "coupon") {
        this.givenForm.GoodsCode = row.couponCode;
        this.givenForm.GoodsName = row.couponName;
      }
      this.satisfyVisible = false;
    },

    hanCurrChangeSatisfy(val) {
      this.currPageSatisfy = val;
      this.getSatisfyData();
    },

    /**
     * 
     * @param {Number} index 下标
     */
    handleDelDetails(index) {
      this.$confirm('将会同时删除赠品信息，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addForm.details.splice(index, 1);
      }).catch(() => { });
    },

    /**
     * 
     * @param {Number} index 下标
     */
    handleAddGiven(index) {
      this.givenDialog = true;
      this.detailsIndex = index;
    },

    /**
     * 点击赠品保存
     */
    handleGivenSave() {
      this.$refs.form2.validate(valid => {
        if (valid) {
          this.addForm.details[this.detailsIndex].givenList.unshift({
            ItemId: this.givenForm.ItemId,
            ItemNo: this.givenForm.ItemNo,
            // Fabh: this.givenForm.Fabh,
            SortId: this.givenForm.SortId,
            GivenType: this.givenForm.GivenType,//赠送类型
            GivenAmount: this.givenForm.GivenAmount,//赠送金额
            GivenQuantity: this.givenForm.GivenQuantity,// 赠送数量
            GoodsCode: this.givenForm.GoodsCode,//赠送货品编号优惠券/商品编号
            GoodsName: this.givenForm.GoodsName,//赠送货品编号优惠券/商品编号
          })
          this.handleGivenReset();
        }
      })
    },

    /**
     * 点击赠品重置
     */
    handleGivenReset() {
      this.$refs.form2.resetFields();
    },

    /**
     * 赠品删除
     */
    handleGivenDel({ $index }) {
      this.addForm.details[this.detailsIndex].givenList.splice($index, 1);
    },

    /**
     * 提交表单
     */
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = {
            EntId: this.entId,
            Fabh: this.fabh,
            Title: this.addForm.title,
            AddTime: this.addForm.addTime,
            StartDate: this.addForm.start,
            EndDate: this.addForm.end,
            ClientType: this.addForm.clientType.join(','),
            MemberGrade: this.addForm.grade,
            Status: this.addForm.status,
            Detail: this.addForm.details.slice(1).map(item => {
              return {
                Fabh: this.fabh,
                SortId: item.SortId,
                MeetAmount: item.MeetAmount,
                MaxNum: item.MaxNum,
                Item: item.givenList.map(item2 => {
                  return {
                    ItemId: item2.ItemId,
                    ItemNo: item2.ItemNo,
                    Fabh: this.fabh,
                    SortId: item2.SortId,
                    GivenType: item2.GivenType,
                    GivenAmount: item2.GivenAmount,
                    GivenQuantity: item2.GivenQuantity,
                    GoodsCode: item2.GoodsCode,
                    GoodsName: item2.GoodsName
                  }
                })
              }
            })
          }

          this.$request({
            url: "/Management/PromAdmin/SaveOrderPromPlan",
            method: "post",
            data: {
              jsonStr: JSON.stringify(data)
            }
          }).then((res) => {
            let type = "success";
            if (res.success) {
              type = "success";
            } else {
              type = "error";
            }
            this.$message({
              message: res.message,
              type: type
            });
          }).catch((err) => {
            window.console.log(err);
          });
        }
      })
    },
  },
}
</script>
<style lang='css' scoped>
.addAmount {
  width: 100%;
  height: 100%;
}

/**赠品方案详情 */
.details {
  margin-top: 10px;
  display: flex;
}

.details:first-of-type {
  margin-top: 0;
}

.form-item {
  display: flex;
}
</style>